import cx from 'classnames';
import { intcomma } from 'journalize';
import { h } from 'preact';

import PartyPill from './PartyPill';

import formatPercent from '../utils/format-percent';

function CandidateRow({
  candidate,
  color,
  excludePartyInitial,
  totalVotes,
  contestIsCalled,
  contestIsUncontested,
  isViewable,
  shortName,
  noWinner,
  votes,
}) {
  const rowClass = cx('candidate', 'contest__candidate-row', {
    'contest__candidate-row--winner':
      !noWinner && contestIsCalled && candidate.is_winner,
    'contest__candidate-row--hidden': !isViewable,
  });

  const percentClass = cx('candidate__pct-symbol', {
    'always-hidden': contestIsUncontested || totalVotes <= 0,
  });

  votes = votes != null ? votes : candidate.votes;

  return (
    <tr class={rowClass}>
      <td class="candidate__cell candidate__party">
        <PartyPill
          excludePartyInitial={excludePartyInitial}
          party={candidate.party}
          style={{ backgroundColor: color }}
        />
      </td>
      <th class="candidate__cell candidate__name">
        {contestIsCalled && candidate.is_winner && '\u2713 '}
        {shortName ? candidate.ballot_sort_name : candidate.ballot_name}{' '}
        {candidate.is_incumbent && (
          <span class="pill pill--basic">Incumbent</span>
        )}
      </th>
      <td class="candidate__cell candidate__votes">
        {contestIsUncontested ? '-' : intcomma(votes)}
      </td>
      <td class="candidate__cell candidate__pct">
        {contestIsUncontested || totalVotes <= 0
          ? '-'
          : formatPercent(votes, totalVotes)}
        <span class={percentClass}>%</span>
      </td>
    </tr>
  );
}

CandidateRow.defaultProps = {
  excludePartyInitial: false,
  isViewable: true,
  noWinner: false,
  shortName: false,
  votes: null,
};

export default CandidateRow;



// WEBPACK FOOTER //
// ./components/CandidateRow.js